module.exports = __webpack_public_path__ + "img/insta.33e373a1.svg";